import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";

const GeneratedDocCell = ({ claim }) => {
  const { t } = useTranslation();

  const downloadStyles = {
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
    background: "#f9fafb",
    padding: "6px 12px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    transition: "all 0.2s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  };

  const disabledStyles = {
    fontSize: "14px",
    fontWeight: "500",
    color: "#9ca3af",
    background: "#f3f4f6",
    padding: "6px 12px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    display: "inline-flex",
    alignItems: "center",
    cursor: "not-allowed",
  };

  return (
    <td>
      {claim.status !== "Waiting for Admin Action" && claim.status !== "Rejected" ? (
        claim.generatedDocument ? (
          <a
            href={claim.generatedDocument}
            download
            target="_blank"
            rel="noopener noreferrer"
            style={downloadStyles}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#f3f4f6";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#f9fafb";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <FontAwesomeIcon icon={faFilePdf} className="text-danger" />
            <span>{t("tableValues.downloadDocument")}</span>
          </a>
        ) : (
          <span style={disabledStyles}>{t("tableValues.waitForApproval")}</span>
        )
      ) : claim.status !== "Rejected" ? (
        <span style={disabledStyles}>{t("tableValues.waitForApproval")}</span>
      ) : (
        <span style={disabledStyles}>{t("Admin Rejected Claim")}</span>
      )}
    </td>
  );
};

export default GeneratedDocCell;
